import React from 'react';
import { Edit, useForm, useSelect } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { PermissionDto } from '@wellverse/shared-ts';

export const RoleEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'roles' });
  const { selectProps: permissionSelectProps } = useSelect<PermissionDto>({
    resource: 'permissions',
    optionLabel: (item) => `${item.resource}:${item.action}`,
    optionValue: 'id',
  });

  const role = queryResult?.data?.data;

  return (
    <Edit resource="roles" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          ...formProps.initialValues,
          permissionIds: role?.permissions?.map((p: { id: string }) => p.id) || [],
        }}
      >
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item label="Permissions" name="permissionIds">
          <Select
            {...permissionSelectProps}
            mode="multiple"
            placeholder="Select permissions"
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
